/**
 * Value-added tax rate
 */
export type VatRate = 'ZERO' | 'TWENTY_SEVEN' | 'EIGHTEEN';

export const VatRate = {
  TwentySeven: 'TWENTY_SEVEN' as VatRate,
  Eighteen: 'EIGHTEEN' as VatRate,
  Zero: 'ZERO' as VatRate,
};
